const renderOpeningInfos = function() {

    $('#resultSet .entry').each(function(index) {
        let obj, intervalObj, item;
        obj = $(this);
        item = {};
        intervalObj = obj.find('.date-interval');
        if (intervalObj.length > 0) {
            item.ObjectID = intervalObj.data('objectid');
            item.ObjectType = intervalObj.data('objecttype');
            item.MetaExperience = intervalObj.data('experience');
            loadOpeningHours(item);
        }
    });

};

const loadOpeningHours = function(item) {

    let object = $('.date-interval[data-objectid="' + item.ObjectID + '"]');
    $.ajax({
        type: "POST",
        url: '/index.php?id=' + rootPage + '&type=1890&L=' + $('#td').data('syslanguageuid'),
        data: "object=" + JSON.stringify(item) + '&style=tdLists',
        beforeSend: function() {
            object.before('<span class="fas fa-circle-notch fa-spin"></span>');
            object.attr("aria-busy", true);
        },
        success: function(result) {
            object.html(result);
        },
        error: function() {
            if (object.prev().hasClass('fa-circle-notch')) {
                object.prev().remove();
            }
        },
        complete: function(result) {
            if (object.prev().hasClass('fa-circle-notch')) {
                object.prev().remove();
            }
            object.attr("aria-busy", false);
        }
    });
};

const ulmRenderOpeningInfos = function() {
    $('#ulm .list .entry.gastro:not(.openingHoursJobDone), #ulm .list .entry.poi:not(.openingHoursJobDone)').each(function(i) {
        let obj, intervalObj, item;
        obj = $(this);
        item = {};
        intervalObj = obj.find('.date-interval');
        if (intervalObj.length > 0) {
            item.ObjectID = intervalObj.data('objectid');
            item.ObjectType = intervalObj.data('objecttype');
            item.MetaExperience = intervalObj.data('experience');
            item.obj = obj;
            ulmLoadOpeningHours(item);
            $(this).addClass('openingHoursJobDone');
        }
    });
};

const ulmLoadOpeningHours = function(item) {

    let object = item.obj.find('.content .ulm-opening-hours');
    console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', object);
    $.ajax({
        type: "POST",
        url: '/index.php?id=' + rootPage + '&type=1890&L=' + $('#ulm').data('syslanguageuid'),
        data: "object=" + JSON.stringify(item) + '&style=ulm',
        beforeSend: function() {
            object.html('<span class="fas fa-spinner fa-spin opening-hours-spinner"></span>');
            object.attr("aria-busy", true);
        },
        success: function(result) {
            object.html(result);
        },
        error: function() {
            object.find('.opened-spinner').remove();
        },
        complete: function(result) {
            object.find('.opened-spinner').remove();
            object.attr("aria-busy", false);
        }
    });
};
